import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';

import {
    captureConsoleIntegration,
    captureException,
    init,
    reactRouterV6BrowserTracingIntegration,
} from '@sentry/react';
import React from 'react';
import AppConfig from './utils/appconfig';

export function initializeSentry() {
    init({
        dsn: AppConfig.sentryDsn,
        integrations: [
            reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            captureConsoleIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: AppConfig.sentryTracesSampleRate,
        // Session Replay
        replaysSessionSampleRate: AppConfig.sentryReplaysSessionSampleRate,
        replaysOnErrorSampleRate: AppConfig.sentryReplaysOnErrorSampleRate,
        ignoreErrors: ['Invalid vr type ox - using'],
    });
}

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
    captureException(event.reason);
});

// Global error handler for uncaught errors
window.addEventListener('error', (event) => {
    captureException(event.error);
});
